import {Component, OnInit, QueryList, ViewChild, ViewChildren,} from '@angular/core';
import {FormBuilderComponent} from '../../../../components/form-buider/form-buider.component';
import {FormControl} from '@angular/forms';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {DataManagementAppService} from 'src/app/services/data-management-app.service';
import {MatDialog} from '@angular/material/dialog';
import {ShowDialogsComponent} from 'src/app/components/show-dialogs/show-dialogs.component';

@Component({
  selector: 'app-configure-connection',
  template: `
    <div class="dc-page">
      <!-- Page header -->
      <div class="dc-pagehead">
        <div>
          <h1>Data Connections</h1>
          <p>Connections your datasets read from and write to.</p>
        </div>
        <button type="button" class="dc-btn-primary" (click)="clearFormData()">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
               stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M12 5v14M5 12h14"/>
          </svg>
          New connection
        </button>
      </div>

      <!-- Type pills -->
      <div class="dc-pills">
        <span
          class="dc-pill"
          [class.active]="selectedConnectionIndex === i"
          *ngFor="let connection of default_connection_types; let i = index"
          (click)="onConnectionSelect(i)"
        >
          <span class="dot" *ngIf="selectedConnectionIndex === i"></span>
          {{ connection.name | textpretty }}
        </span>
      </div>

      <!-- 2-column grid -->
      <div class="dc-grid2">
        <!-- LEFT: form card -->
        <div>
          <div class="dc-panel">
            <div class="dc-panel-b">
              <!-- Empty state -->
              <div *ngIf="selectedConnectionIndex === -1" class="dc-empty">
                Select a connection type to begin.
              </div>

              <!-- Form -->
              <ng-container *ngIf="selectedConnectionIndex > -1">
                <div class="dc-panel-title">
                  {{ default_connection_types[selectedConnectionIndex].name | textpretty }}
                  connection
                </div>

                <mat-form-field class="dc-field" style="width: 100%;">
                  <mat-label>Enter data connection name</mat-label>
                  <input
                    matInput
                    [formControl]="prep_output.connection_name"
                    name="connection_name"
                    required
                    [readonly]="is_edit"
                  />
                  <mat-hint *ngIf="is_edit" class="text-sm" style="color:#6B7280"
                  >This input is disabled for editing.
                  </mat-hint>
                </mat-form-field>

                <div class="dc-checks">
                  <mat-checkbox
                    class="example-margin"
                    [formControl]="prep_output.is_source"
                  >Is Source
                  </mat-checkbox>
                  <mat-checkbox
                    class="example-margin"
                    [formControl]="prep_output.is_destination"
                  >Is Destination
                  </mat-checkbox>
                </div>

                <div class="dc-form-bodies">
                  <div class="dc-form-body">
                    <app-form-buider
                      #formBuilder
                      [FormPayload]="
                        default_connection_types[selectedConnectionIndex]
                          .connection_template.con
                      "
                      [Output]="connection"
                      [fieldWidthInRem]="18"
                      (dataEvent)="getOutput($event, 'con')"
                    ></app-form-buider>
                  </div>
                  <div
                    class="dc-form-body"
                    *ngIf="
                      default_connection_types[selectedConnectionIndex]
                        .connection_template.extra &&
                      default_connection_types[selectedConnectionIndex]
                        .connection_template.extra.length > 0
                    "
                  >
                    <mat-form-field appearance="fill" style="width: 18rem;">
                      <mat-label> Select the type of connection</mat-label>
                      <mat-select [formControl]="plugins_to_connect">
                        <mat-option
                          *ngFor="
                            let option_value of default_connection_types[
                              selectedConnectionIndex
                            ].connection_template.extra
                          "
                          [value]="option_value"
                        >{{ option_value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div
                      *ngIf="plugins_to_connect.value"
                      class="h-[20rem] overflow-y-scroll"
                    >
                      <app-form-buider
                        #formBuilder
                        [FormPayload]="
                          default_connection_types[selectedConnectionIndex]
                            .connection_template[plugins_to_connect.value]
                        "
                        [Output]="params"
                        [fieldWidthInRem]="18"
                        (dataEvent)="getOutput($event, 'param')"
                      ></app-form-buider>
                    </div>
                  </div>
                </div>

                <div class="dc-form-actions">
                  <button
                    type="button"
                    class="dc-btn-ghost"
                    (click)="testConnection()"
                    [disabled]="isTestingConnection"
                  >
                    {{ isTestingConnection ? 'Testing...' : 'Test connection' }}
                  </button>
                  <button
                    type="button"
                    class="dc-btn-primary"
                    (click)="submitform()"
                    [disabled]="isSavingConnection"
                  >
                    {{ isSavingConnection ? 'Saving...' : 'Save' }}
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- RIGHT: connections table card -->
        <div>
          <div class="dc-panel">
            <div class="dc-tbl-h">Your connections</div>
            <table
              mat-table
              [dataSource]="availableConnections"
              class="dc-table"
            >
              <ng-container matColumnDef="connection_name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  [matTooltip]="element.connection_name"
                  class="dc-cname"
                  (click)="
                    element.connection_type_id != 'Files_Upload_(xlsx)'
                      ? editConnection(element)
                      : null
                  "
                >
                  {{ element.connection_name | textpretty | titlecase }}
                </td>
              </ng-container>

              <ng-container matColumnDef="connection_type_id">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element">
                  <span class="dc-type-chip" *ngIf="element.connection_type_id">
                    {{ element.connection_type_id | textpretty }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef>Role</th>
                <td mat-cell *matCellDef="let element">
                  <span class="dc-roles">
                    <span class="dc-role in" *ngIf="element.is_source">Input</span>
                    <span class="dc-role out" *ngIf="element.is_destination">Output</span>
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="dc-actions-h">Actions</th>
                <td mat-cell *matCellDef="let element">
                  <div
                    class="dc-row-actions"
                    *ngIf="
                      element?.id &&
                      element.connection_type_id != 'Files_Upload_(xlsx)'
                    "
                  >
                    <button
                      type="button"
                      class="dc-iconbtn"
                      matTooltip="Edit Connection"
                      (click)="editConnection(element)"
                    >
                      <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
                           stroke="currentColor" stroke-width="1.8"
                           stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 20h9"/>
                        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="dc-iconbtn danger"
                      matTooltip="Delete Connection"
                      (click)="removeConnection(element.connection_name)"
                    >
                      <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
                           stroke="currentColor" stroke-width="1.8"
                           stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18"/>
                        <path d="M8 6V4h8v2"/>
                        <path d="M6 6l1 14h10l1-14"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-paginator
              [length]="default_connection_types"
              [pageSize]="4"
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./configure-connection.component.scss'],
})
export class ConfigureConnectionComponent implements OnInit {
  @ViewChildren('formBuilder') payloadForms?: QueryList<FormBuilderComponent>;
  @ViewChild(MatPaginator) paginator: MatPaginator | any;
  availableConnections: any = [];
  displayedColumns: string[] = [
    'connection_name',
    'connection_type_id',
    'role',
    'actions',
  ];
  selectedConnectionIndex = -1;
  connection: any;
  params: any;
  prep_output: any = {
    connection_name: new FormControl(),
    is_source: new FormControl(),
    is_destination: new FormControl(),
  };
  output: any = {
    connection_name: '',
    connection_type: '',
    connection_conf: '',
    is_source: '',
    is_destination: '',
    idp_name: '',
  };
  plugins_to_connect = new FormControl();
  default_connection_types: any;
  is_edit: boolean = false;
  isTestingConnection = false;
  isSavingConnection = false;
  protected readonly NaN = NaN;

  constructor(
    private dataManagementServices: DataManagementAppService,
    private snackBar: SharedFeaturesService,
    private dialog: MatDialog
  ) {
  }

  async ngOnInit() {
    this.default_connection_types =
      await this.dataManagementServices.getConnectionTemplate('');
    this.refreshConnection();
  }

  refreshConnection() {
    this.dataManagementServices.getConnections('').subscribe({
      next: (connection) => {
        const dataSource = new MatTableDataSource(connection);
        dataSource.paginator = this.paginator;
        this.availableConnections = dataSource;
      },
    });
  }

  onConnectionSelect(index: number): void {
    this.clearFormData();
    this.selectedConnectionIndex = index;
  }

  getOutput(data: any, type: string) {
    if (type === 'con') this.connection = data;
    else this.params = data;
  }

  removeConnection(conn_name: string) {
    const versionDialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Delete connection',
        message: `Delete '${conn_name}'? This permanently removes the connection.`,
        confirmText: 'Delete',
        danger: true,
      },
      disableClose: false,
    });
    versionDialogRef.afterClosed().subscribe((selection) => {
      if (selection) {
        this.dataManagementServices
          .delete_connections({connection_name: conn_name})
          .subscribe({
            next: (response: any) => {
              this.snackBar.openSnackBar(
                response.message,
                'Close',
                'success-snackbar'
              );
              this.refreshConnection();
            },
            error: (error) => {
              this.snackBar.openSnackBar(
                error.error.error,
                'Close',
                'error-snackbar'
              );
            },
          });
      }
    });
  }

  private buildSubmitData(): any {
    const temp = {
      con: this.connection,
      params: this.params !== undefined ? this.params : {},
    };
    const submitData = {...this.output};
    submitData.idp_name =
      this.params !== undefined ? this.plugins_to_connect.value : null;
    submitData.connection_name = this.prep_output.connection_name.value;
    submitData.connection_type =
      this.default_connection_types[this.selectedConnectionIndex].name;
    submitData.is_source = this.prep_output.is_source.value
      ? this.prep_output.is_source.value
      : false;
    submitData.is_destination = this.prep_output.is_destination.value
      ? this.prep_output.is_destination.value
      : false;
    submitData.connection_conf = temp;
    return submitData;
  }

  testConnection() {
    this.payloadForms?.map((form) => form.validateForm());
    if ('invalid' in this.connection) {
      this.snackBar.openSnackBar(
        '"Kindly provide values for all the mandatory fields."',
        'Close',
        'error-snackbar'
      );
      return;
    }
    this.isTestingConnection = true;
    const testData = {
      connection_type: this.default_connection_types[this.selectedConnectionIndex].name,
      connection_conf: this.buildSubmitData().connection_conf,
    };
    this.dataManagementServices.test_connection(testData).subscribe({
      next: (response: any) => {
        this.isTestingConnection = false;
        this.snackBar.openSnackBar(
          response.message || 'Connection test successful.',
          'Close',
          'success-snackbar'
        );
      },
      error: (error: any) => {
        this.isTestingConnection = false;
        this.snackBar.openSnackBar(
          error.error?.error || 'Connection test failed.',
          'Close',
          'error-snackbar'
        );
      },
    });
  }

  submitform() {
    this.payloadForms?.map((form) => form.validateForm());
    if ('invalid' in this.connection) {
      this.snackBar.openSnackBar(
        '"Kindly provide values for all the mandatory fields."',
        'Close',
        'error-snackbar'
      );
    } else {
      const submitData = this.buildSubmitData();
      console.debug('Output', submitData);
      this.isSavingConnection = true;
      this.dataManagementServices
        .save_connections(submitData, this.is_edit)
        .subscribe({
          next: (response: any) => {
            this.isSavingConnection = false;
            if (response) {
              this.snackBar.openSnackBar(
                response.message,
                'Close',
                'success-snackbar'
              );
              this.clearFormData();
              this.refreshConnection();
            }
          },
          error: (error: any) => {
            this.isSavingConnection = false;
            this.snackBar.openSnackBar(
              error.error.error,
              'Close',
              'error-snackbar'
            );
          },
        });
    }
  }

  editConnection(connection: any) {
    this.is_edit = true;
    for (const [index, conn] of this.default_connection_types.entries()) {
      if (conn.name == connection.connection_type_id) {
        this.selectedConnectionIndex = index;
        this.prep_output.connection_name.setValue(connection.connection_name);
        this.prep_output.is_source.setValue(connection.is_source);
        this.prep_output.is_destination.setValue(connection.is_destination);
        if ('con' in connection.connection_conf) {
          this.connection = connection.connection_conf.con;
          this.plugins_to_connect.setValue(connection.idp_name);
          this.params = connection.connection_conf.params;
        } else {
          this.connection = connection.connection_conf;
        }
      }
    }
  }

  clearFormData() {
    this.is_edit = false;
    this.selectedConnectionIndex = -1;
    this.connection = null;
    this.params = null;
    this.plugins_to_connect.setValue(null);
    for (const key of Object.keys(this.prep_output)) {
      this.prep_output[key].setValue(null);
    }
    for (const key of Object.keys(this.output)) {
      this.output[key] = null;
    }
  }
}
